export default "__VITE_ASSET__Bs1tOyEG__"